import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {MensajeService} from './Mensaje.Service';
import {MensajeComponent} from "./Mensaje.component";
import {AlertaComponent} from "./Alerta/Alerta.component";
import {InformacionComponent} from './Informacion/Informacion.component';
import {PipesModule} from '../Pipes/Pipes.module';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {DialogoComponent} from './Dialogo/Dialogo.component';
import {AlertaTimerComponent} from './AlertaTimer/AlertaTimer.component';

@NgModule({
    declarations:
        [
            MensajeComponent,
            AlertaComponent,
            InformacionComponent,
            DialogoComponent,
            AlertaTimerComponent
        ],
    imports:
        [
            CommonModule,
            PipesModule,
            AngularSvgIconModule.forRoot(),
        ],
    exports:
        [
            MensajeComponent,
            AlertaComponent,
            InformacionComponent,
            DialogoComponent,
            AlertaTimerComponent
        ],
    providers:
        [
            MensajeService
        ]
})

export class MensajeModule {
}
